import { createContext, useContext } from 'react'

import { validateContext } from 'shared/utils'

export const EventTypeStateContext = createContext({})
export const EventTypeActionsContext = createContext({})

export const useEventTypeContext = () => validateContext(useContext(EventTypeStateContext), {
  contextName: 'EventTypeStateContext',
  providerName: 'EventTypeProvider'
})

const useEventTypeActions = () => validateContext(useContext(EventTypeActionsContext), {
  contextName: 'EventTypeActionsContext',
  providerName: 'EventTypeProvider'
})

export const useEventType = () => {
  const { eventType } = useEventTypeContext()

  return eventType
}

export const useSetEventType = () => {
  const { setEventType } = useEventTypeActions()

  return setEventType
}
